/** Flux unique : toi + le système (rappels, brouillon R). */
import type { DashActivityItem } from "./types";

const KIND: Record<DashActivityItem["kind"], string> = {
  payment: "Paiement",
  invoice: "Facture",
  credit: "Avoir",
  reminder: "Rappel",
  recurring: "Récurrente",
};

type ActivityFeedProps = {
  items?: DashActivityItem[];
  onOpen?: (item: DashActivityItem) => void;
};

export function ActivityFeed({ items = [], onOpen }: ActivityFeedProps) {
  return (
    <section className="fx-panel fx-activity" aria-label="Activité récente">
      <div className="fx-panel__head">
        <h2>Activité récente</h2>
      </div>
      {items.length === 0 ? (
        <p className="fx-panel__empty">Paiements, pièces, rappels auto et brouillons récurrents s’afficheront ici.</p>
      ) : (
        <ul className="fx-dash-list">
          {items.map((row) => (
            <li key={row.id}>
              {onOpen && row.open ? (
                <button type="button" className="fx-dash-row" onClick={() => onOpen(row)}>
                  <strong>
                    <em className={`fx-dash-kind fx-dash-kind--${row.kind}`}>{KIND[row.kind]}</em>
                    {row.title}
                  </strong>
                  <span>{row.meta}</span>
                </button>
              ) : (
                <>
                  <strong>
                    <em className={`fx-dash-kind fx-dash-kind--${row.kind}`}>{KIND[row.kind]}</em>
                    {row.title}
                  </strong>
                  <span>{row.meta}</span>
                </>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
